import { Box, defineStyle } from '@chakra-ui/react';
import type { RefObject } from 'react';
import { BackIcon } from '@halo/ui-chat-react';

export interface MediaCallDragLabelProps {
  isMouseOver: boolean;
  hoverOverRef: RefObject<HTMLDivElement | null>;
  direction: {
    isLeft: boolean;
    isRight: boolean;
  };
}

const left = defineStyle({
  right: 0,
  display: 'flex',
  borderRadius: ' 0 10px 10px 0',
  transform: 'translate(100%, -50%)',
});

const right = defineStyle({
  left: 0,
  display: 'flex',
  borderRadius: '10px 0 0 10px',
  transform: 'translate(-100%, -50%)',
});

export function MediaCallDragLabel(props: MediaCallDragLabelProps) {
  const { hoverOverRef, isMouseOver, direction } = props;

  return (
    <Box
      ref={hoverOverRef}
      position={'absolute'}
      top={'50%'}
      alignItems={'center'}
      justifyContent={'center'}
      width={'23px'}
      height={'87px'}
      bg={'whiteAlpha.100'}
      border={'1px solid rgb(163 163 163 / 40%)'}
      css={{
        ...((isMouseOver && (direction.isLeft ? left : direction.isRight ? right : {})) || {
          display: 'none',
        }),
      }}
    >
      <BackIcon style={{ transform: direction.isLeft && isMouseOver ? 'rotateZ(180deg)' : '' }} />
    </Box>
  );
}

export default memo(MediaCallDragLabel);
